import ReactOnRails from 'react-on-rails';
import { Root } from '../bundles/hisabi/Root';

// This is how react_on_rails can see the components in the browser.
ReactOnRails.register({
  Root,
});
